/**
 * Shared `CALL { … }` subquery projecting an anchor's fault knowledge: every
 * `EXHIBITS_SYMPTOM` edge plus the causes humans confirmed on Problems that
 * induce the same symptom. Spliced into the Equipment relationships and Part
 * detail queries so every surface shares one shape (`extractFaultList`).
 *
 * The block yields a `faults` list of
 * `{ symptom, exhibits_status, exhibits_source, first_observed_at,
 * last_observed_at, causes[] }`
 * where each cause row is `{ cause, confirmations }`.
 */
export function faultSymptomsCallBlock(alias: string): string {
  return `
  CALL {
    WITH ${alias}
    OPTIONAL MATCH (${alias})-[x:EXHIBITS_SYMPTOM]->(sym:FaultSymptom)
    OPTIONAL MATCH (sym)<-[:INDUCES]-(episode:Problem)-[cb:CAUSED_BY {status: 'confirmed'}]->(cause:FaultCause)
    WHERE episode.record_kind IS NULL
    WITH sym, x, cause, count(cb) AS confirmations
    WITH sym, x, collect(
      CASE WHEN cause IS NULL THEN null
      ELSE { cause: cause, confirmations: confirmations } END
    ) AS causeRows
    WITH collect(
      CASE WHEN sym IS NULL THEN null
      ELSE {
        symptom: sym,
        exhibits_status: x.status,
        exhibits_source: x.source,
        first_observed_at: x.first_observed_at,
        last_observed_at: x.last_observed_at,
        causes: [c IN causeRows WHERE c IS NOT NULL]
      }
      END
    ) AS faultRows
    RETURN [r IN faultRows WHERE r IS NOT NULL] AS faults
  }`
}
